// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2026-01-24 02:54:28 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159989 $
//  Purpose   : upload package
// =============================================================================
import * as reducers from './reducers';
export { reducers };
import * as actions from './actions';
export { actions };
let selectors = {
    uploads: (root)=>root.data.upload.uploads
};
export { selectors };
